import type { PutCommandOutput } from "@aws-sdk/lib-dynamodb";
import type { upsertPolicy } from "@clientportal/core/types";

import { api } from "@/shared/api/api";
import type { TApiPolicyPayload } from "@/shared/api/types/clientPortal";

const policyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPolicyForCognitoUser: builder.query<TApiPolicyPayload, string>({
      query: (cognitoId) => `/policy/${cognitoId}`,
      providesTags: ["Policy"],
    }),
    upsertPolicyForCognitoUser: builder.mutation<PutCommandOutput, { policies: upsertPolicy; cognitoId: string }>({
      query: ({ policies, cognitoId }) => ({
        url: `/policy/${cognitoId}`,
        method: "PUT",
        body: policies,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPolicyForCognitoUserQuery, useUpsertPolicyForCognitoUserMutation, endpoints } = policyApi;
